import React from 'react';
import { toPath } from 'svg-points';
import { Stroke } from '@magicyard/blanksy-game/src/Types';

interface LinePathProps {
  line: Stroke;
}
export const LinePath: React.FC<LinePathProps> = ({ line }) => {
  const d = toPath(line.points);

  return (
    <path
      d={d}
      stroke={line.color}
      strokeWidth={line.width}
      strokeLinecap={'round'}
      strokeLinejoin={'round'}
      fill="transparent"
    />
  );
};
